<template>
	<div>
		<el-dialog
			:title="titleDialog"
			:visible="showDialog"
			@close="close"
			@open="create"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			width="35%"
		>
			<form autocomplete="off" @submit.prevent="submit">
				<v-row>
					<v-col cols="12" xl="6" lg="6" md="6" sm="12">
						<div class="form-group" :class="{ danger: errors.name }">
							<label>Nombre</label>
							<el-input v-model="form.name"></el-input>
							<small
								class="error--text"
								v-if="errors.name"
								v-text="errors.name[0]"
							></small>
						</div>
					</v-col>
					<v-col cols="12" xl="6" lg="6" md="6" sm="12">
						<div class="form-group" :class="{ danger: errors.short }">
							<label>Abreviatura</label>
							<el-input v-model="form.short"></el-input>
							<small
								class="error--text"
								v-if="errors.short"
								v-text="errors.short[0]"
							></small>
						</div>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" xl="6" lg="6" md="6" sm="12">
						<div class="form-group" :class="{ danger: errors.time_of_start }">
							<label>Hora Inicio</label>
							<el-time-picker
                                v-model="form.time_of_start"
                                format="HH:mm"
                                value-format="HH:mm:ss"
                                placeholder="Seleccionar"
                                dusk="form.time_of_start"
                                :clearable="false"
                              ></el-time-picker>
							<small
								class="error--text"
								v-if="errors.time_of_start"
								v-text="errors.time_of_start[0]"
							></small>
						</div>
					</v-col>
					<v-col cols="12" xl="6" lg="6" md="6" sm="12">
						<div class="form-group" :class="{ danger: errors.time_of_end }">
							<label>Hora Fin</label>
							<el-time-picker
                                v-model="form.time_of_end"
                                format="HH:mm"
                                value-format="HH:mm:ss"
                                placeholder="Seleccionar"
                                dusk="form.time_of_end"
                                :clearable="false"
                              ></el-time-picker>
							<small
								class="error--text"
								v-if="errors.time_of_end"
								v-text="errors.time_of_end[0]"
							></small>
						</div>
					</v-col>
				</v-row>
				<div class="form-actions text-right mt-3 mb-3">
					<el-button type="danger" @click.prevent="close()">Cancelar</el-button>
					<el-button type="primary" native-type="submit" :loading="loading">
						<template v-if="loading">
							Guardando...
						</template>
						<template v-else>
							Guardar
						</template>
					</el-button>
				</div>
			</form>
		</el-dialog>
	</div>
</template>

<script>
export default {
	props: ['showDialog', 'recordId'],
	data() {
		return {
			loading: false,
			titleDialog: null,
			resource: 'shifts',
			valid: false,
			errors: {},
			form: {},
			rules: {
				name: [{ required: true, message: 'El nombre es requerido', trigger: 'blur' }],
			},
		};
	},
	created() {
        this.initForm()
    },
	methods: {
		initForm() {
			this.errors = {};
			this.form = {
				id: null,
				name: null,
				short: null,
				time_of_start: "12:00:00",
				time_of_end: "12:00:00",
			};
		},
		create() {
			this.titleDialog = this.recordId ? 'Editar piso' : 'Nuevo piso';
			if (this.recordId) {
				this.$http.get(`/${this.resource}/record/${this.recordId}`).then((response) => {
					this.form = response.data.data;
				});
			}
		},
		submit() {
			this.loading = true;
			this.$http
				.post(`/${this.resource}`, this.form)
				.then((response) => {
					if (response.data.success) {
						this.$message.success(response.data.message);
						this.$eventHub.$emit('reloadData', this.resource);
						this.close();
					} else {
						this.$message.error(response.data.message);
					}
				})
				.catch((error) => {
					if (error.response.status === 422) {
						this.errors = error.response.data.errors;
					} else {
						this.$message.error(error.response.data.message);
					}
				})
				.then(() => {
					this.loading = false;
				});
		},
		close() {
			this.$emit('update:showDialog', false);
			this.initForm();
		},
	},
};
</script>
